export const getAgenteAccessToken = () =>
  localStorage.getItem("agenteAccessToken");
export const getInterToken = () => {
  const token = JSON.parse(sessionStorage.getItem("carPrice")).token;
  if (token) return token;
  throw new Error("No existe ningún token cargado de Inter");
};
